import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}rol_turno`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}rol_turno/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}rol_turno/${id}`);
  return response;
};

const getFilter = async (periodo_id, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}rol_turno/filter/${periodo_id}/${anio}/${num_periodo}`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}rol_turno/create`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}rol_turno/${payload.id}`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}rol_turno/${id}`);
  return response;
};

const getByAnioEmpleado = async (anio, empleado_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}rol_turno/filter/anio/${anio}/empleado/${empleado_id}`);
  return response;
};

export { getAll, getList, getById, getFilter, insert, update, drop, getByAnioEmpleado };